export const buildUniqueId = (prefix, suffix) => {
    let id = '';
    if (prefix)
        id += `${prefix}-`;
    id += Math.floor(Date.now() / 100).toString();
    if (suffix)
        id += `-${suffix}`;
    return id;
};
